var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.header?'header':''},[_c('van-nav-bar',{attrs:{"title":_vm.title,"right-text":_vm.rightText},on:{"click-left":_vm.toBack,"click-right":_vm.onClickRight},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('img',{attrs:{"src":require("@/assets/back.png"),"alt":"返回","width":"21","height":"21"}})]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148d85a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = null
// module chunks = 